var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var CookieObject = /** @class */ (function () {
    function CookieObject(name, value, expires, path) {
        this.name = name;
        this.value = value;
        if (expires == null) {
            var timestamp = Date.now();
            var date = new Date(timestamp);
            date.setFullYear(date.getFullYear() + 20);
            this.expires = date;
        }
        else {
            this.expires = expires;
        }
        this.path = path;
    }
    return CookieObject;
}());
export { CookieObject };
var CookieHandler = /** @class */ (function () {
    function CookieHandler(dom) {
        var _this = this;
        this.GetCookie = function (name) { return __awaiter(_this, void 0, void 0, function () {
            var cookies, cookie, index, parameters, name_1, value, expires, path;
            return __generator(this, function (_a) {
                cookies = this.dom.cookie.split(";");
                for (cookie in cookies) {
                    index = cookie.search("".concat(name, "="));
                    if (index != -1) {
                        parameters = cookie.split(";", index);
                        name_1 = parameters[0].split("=")[1];
                        value = parameters[1].split("=")[1];
                        expires = new Date(parameters[2].split("=")[1]);
                        path = parameters[3].split("=")[1];
                        return [2 /*return*/, new CookieObject(name_1, value, expires, path)];
                    }
                }
                return [2 /*return*/, null];
            });
        }); };
        this.SetCookie = function (name, value, expires) { return __awaiter(_this, void 0, void 0, function () {
            var timestamp;
            return __generator(this, function (_a) {
                if (expires == null) {
                    timestamp = Date.now();
                    expires = new Date(timestamp);
                    expires.setFullYear(expires.getFullYear() + 20);
                }
                this.dom.cookie = "".concat(name, "=").concat(value !== null && value !== void 0 ? value : "", ";expires=").concat(expires.toUTCString(), ";path=/");
                return [2 /*return*/, new CookieObject(name, value, expires, "/")];
            });
        }); };
        this.DeleteCookie = function (name) {
            // Set expiration date to the past to delete the cookie
            var expires = new Date(0);
            _this.dom.cookie = "".concat(name, "=;expires=").concat(expires.toUTCString(), ";path=/");
        };
        this.dom = dom;
    }
    return CookieHandler;
}());
export default CookieHandler;
